import { render, staticRenderFns } from "./TableTips.vue?vue&type=template&id=4f5cf83e&scoped=true&"
import script from "./TableTips.vue?vue&type=script&lang=js&"
export * from "./TableTips.vue?vue&type=script&lang=js&"
import style0 from "./TableTips.vue?vue&type=style&index=0&id=4f5cf83e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5cf83e",
  null
  
)

export default component.exports